module.exports = __webpack_public_path__ + "static/media/li_may_sung.eafbe9ec.jpg";